import React from 'react';
import WishlistProduct from '../components/common/WishlistProduct';
import { Box, Button, Text } from '@chakra-ui/react';
import { WishlistItemProps, WishlistProps } from '../interfaces/components';
import { PDPWishlist } from '../Icons/PDPWishlist';
import { WishlistContent } from '../content';

function Wishlist({ wishlistProducts, active, activeLocale, setActive, removeFromWishlist }: WishlistProps) {
  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive(false);
        }}
      />
      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '300px', '330px', '330px', '330px']}
        height={['350px', '430px', '450px', '450px', '450px']}
      >
        <Box
          width="100%"
          h="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box h={['180px', '250px', '250px', '250px', '250px']} w="100%" padding="0px" overflow="auto">
            {wishlistProducts &&
              wishlistProducts?.map((wishlistProduct: WishlistItemProps) => (
                <WishlistProduct
                  key={wishlistProduct.product_id}
                  activeLocale={activeLocale}
                  productImage={wishlistProduct.image}
                  productName={wishlistProduct.title}
                  productMetric={wishlistProduct.size}
                  productPrice={wishlistProduct.price}
                  productCurrency={wishlistProduct.currency}
                  removeFromWishlist={() => removeFromWishlist(wishlistProduct.product_id)}
                />
              ))}
          </Box>

          <Box>
            <Text
              w={['200px', '250px', '250px', '250px', '250px']}
              m="0 auto"
              textAlign="center"
              fontSize={['13px', '15px', '15px', '15px', '15px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WishlistContent) in WishlistContent)
                ? WishlistContent['en'].textOne
                : WishlistContent[activeLocale as keyof typeof WishlistContent].textOne}
            </Text>
            <Text
              w={['200px', '250px', '250px', '250px', '250px']}
              m="0 auto"
              textAlign="center"
              fontSize={['13px', '15px', '15px', '15px', '15px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WishlistContent) in WishlistContent)
                ? WishlistContent['en'].textTwo
                : WishlistContent[activeLocale as keyof typeof WishlistContent].textTwo}
            </Text>
          </Box>

          <Button
            leftIcon={<PDPWishlist />}
            border="1px solid #b7b7b7"
            bg="#FFCB00"
            _hover={{ bg: 'rgb(255, 203, 0, 0.4)' }}
            h={['50px', '50px', '50px', '50px', '50px']}
            w="100%"
            color="black"
            borderRadius="0px"
            onClick={() => {
              setActive(false);
              window.GotoScene('loccitane_35');
            }}
          >
            <Text
              fontSize={['12px', '12px', '12px', '14px', '14px']}
              lineHeight={['12px', '12px', '12px', '14px', '14px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              fontWeight="600"
              textAlign="center"
              textTransform="uppercase"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WishlistContent) in WishlistContent)
                ? WishlistContent['en'].button
                : WishlistContent[activeLocale as keyof typeof WishlistContent].button}
            </Text>
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Wishlist;
